
    import './styles.scoped.css';
    export default {
  "panel-wrapper-inner": "awsui_panel-wrapper-inner_lm6vo_1v0fx_5",
  "enable-motion": "awsui_enable-motion_lm6vo_1v0fx_5",
  "panel-wrapper-outer": "awsui_panel-wrapper-outer_lm6vo_1v0fx_6",
  "layout-main-inner": "awsui_layout-main-inner_lm6vo_1v0fx_25",
  "root": "awsui_root_lm6vo_1v0fx_41",
  "layout-wrapper": "awsui_layout-wrapper_lm6vo_1v0fx_42",
  "root-no-scroll": "awsui_root-no-scroll_lm6vo_1v0fx_48",
  "layout": "awsui_layout_lm6vo_1v0fx_25",
  "layout-no-scroll": "awsui_layout-no-scroll_lm6vo_1v0fx_59",
  "layout-main": "awsui_layout-main_lm6vo_1v0fx_25",
  "layout-main-scrollable": "awsui_layout-main-scrollable_lm6vo_1v0fx_69",
  "refresh": "awsui_refresh_lm6vo_1v0fx_72",
  "unfocusable": "awsui_unfocusable_lm6vo_1v0fx_79",
  "drawer": "awsui_drawer_lm6vo_1v0fx_83",
  "drawer-mobile": "awsui_drawer-mobile_lm6vo_1v0fx_89",
  "drawer-closed": "awsui_drawer-closed_lm6vo_1v0fx_92",
  "drawer-refresh": "awsui_drawer-refresh_lm6vo_1v0fx_95",
  "drawer-hidden": "awsui_drawer-hidden_lm6vo_1v0fx_107",
  "has-divider-with-splitpanel": "awsui_has-divider-with-splitpanel_lm6vo_1v0fx_110",
  "opaque-background": "awsui_opaque-background_lm6vo_1v0fx_113",
  "drawer-content": "awsui_drawer-content_lm6vo_1v0fx_117",
  "toggle": "awsui_toggle_lm6vo_1v0fx_158",
  "visual-refresh-toggle": "awsui_visual-refresh-toggle_lm6vo_1v0fx_163",
  "visual-refresh-toggle-type-tools": "awsui_visual-refresh-toggle-type-tools_lm6vo_1v0fx_167",
  "visual-refresh-toggle-type-navigation": "awsui_visual-refresh-toggle-type-navigation_lm6vo_1v0fx_170",
  "button-toggles-container": "awsui_button-toggles-container_lm6vo_1v0fx_180",
  "button-toggles-container-is-hidden": "awsui_button-toggles-container-is-hidden_lm6vo_1v0fx_185",
  "breadcrumbs-desktop": "awsui_breadcrumbs-desktop_lm6vo_1v0fx_199",
  "breadcrumbs-desktop-refresh": "awsui_breadcrumbs-desktop-refresh_lm6vo_1v0fx_203",
  "breadcrumbs-desktop-refresh-with-notifications": "awsui_breadcrumbs-desktop-refresh-with-notifications_lm6vo_1v0fx_210",
  "breadcrumbs-desktop-sticky-header": "awsui_breadcrumbs-desktop-sticky-header_lm6vo_1v0fx_213",
  "content-header-wrapper": "awsui_content-header-wrapper_lm6vo_1v0fx_217",
  "content-header-wrapper-refresh": "awsui_content-header-wrapper-refresh_lm6vo_1v0fx_220",
  "content-header-wrapper-overlapped": "awsui_content-header-wrapper-overlapped_lm6vo_1v0fx_223",
  "content-wrapper": "awsui_content-wrapper_lm6vo_1v0fx_227",
  "content-wrapper-refresh": "awsui_content-wrapper-refresh_lm6vo_1v0fx_230",
  "content-refresh": "awsui_content-refresh_lm6vo_1v0fx_236",
  "content-refresh-overlapped": "awsui_content-refresh-overlapped_lm6vo_1v0fx_239",
  "content-extra-top-padding": "awsui_content-extra-top-padding_lm6vo_1v0fx_243",
  "content-wrapper-first-child": "awsui_content-wrapper-first-child_lm6vo_1v0fx_246",
  "content-header-wrapper-first-child": "awsui_content-header-wrapper-first-child_lm6vo_1v0fx_246",
  "navigation-toggle": "awsui_navigation-toggle_lm6vo_1v0fx_251",
  "tools-toggle": "awsui_tools-toggle_lm6vo_1v0fx_256",
  "navigation": "awsui_navigation_lm6vo_1v0fx_251",
  "navigation-close": "awsui_navigation-close_lm6vo_1v0fx_268",
  "tools": "awsui_tools_lm6vo_1v0fx_256",
  "tools-close": "awsui_tools-close_lm6vo_1v0fx_280",
  "notifications": "awsui_notifications_lm6vo_1v0fx_284",
  "breadcrumbs": "awsui_breadcrumbs_lm6vo_1v0fx_199",
  "content": "awsui_content_lm6vo_1v0fx_217",
  "hide": "awsui_hide_lm6vo_1v0fx_305",
  "mobile": "awsui_mobile_lm6vo_1v0fx_315",
  "open": "awsui_open_lm6vo_1v0fx_321",
  "navigation-panel-exit-state": "awsui_navigation-panel-exit-state_lm6vo_1v0fx_326"
};
  